<script>
import { mapActions } from "vuex";

export default {
  name: "Activate",
  data() {
    return {
      activating: true,
    };
  },
  methods: {
    ...mapActions(["activate"])
  },
  async mounted() {
    this.$preloader.fadeOut();
    await this.activate({ token: this.$route.params.token });
    this.activating = false;
  },
};
</script>

<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-7 ml-auto mr-auto">
        <card class="p-3 mb-0">
          <img
            class="mb-3"
            style="filter: brightness(1) invert(0)"
            src="img/brand/gcbridge.png?ts=202407121730"
            alt=""
          />
          <p v-if="activating" class="color-gray-description">
            Activating your user...
          </p>
          <p v-else class="color-gray-description mb-3">
            Your user has been activated! Now login and start using our AI tools!
          </p>
          <router-link class="btn w-100" :to="{ name: 'login'}">
            Go to login
          </router-link>
        </card>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.card {
  background: white;
  & * {
    color: inherit;
  }
}
</style>
